import { WebMercatorViewport } from "@deck.gl/core";
import { useEffect, useState } from "react";

interface MapContextMenuState {
  x: number;
  y: number;
  lat?: number;
  lng?: number;
}

export function useMapContextMenu() {
  const [contextMenuCoords, setContextMenuCoords] = useState<MapContextMenuState>({
    x: 0,
    y: 0,
    lat: 0,
    lng: 0,
  });
  const [show, setShow] = useState(false);

  useEffect(() => {
    const keyPressFunction = (event: KeyboardEvent) => {
      if (event.code === "Escape") {
        setShow(false);
      }
    };

    document.addEventListener("keydown", keyPressFunction);
    return () => document.removeEventListener("keydown", keyPressFunction);
  }, []);

  const toggleContextMenu = ({ ...e }) => {
    const { x, y } = e.point;
    const viewport = new WebMercatorViewport({
      width: window.innerWidth,
      height: window.innerHeight,
      zoom: e.target.getZoom(),
      longitude: e.target.getCenter().lng,
      latitude: e.target.getCenter().lat,
    });
    const [lng, lat] = viewport.unproject([x, y]);
    setContextMenuCoords({ x, y, lat, lng });
    setShow(true);
  };

  const openContextMenu = () => {
    setShow(true);
  };
  const closeContextMenu = () => {
    setShow(false);
  };

  return {
    toggleContextMenu,
    showContextMenu: show,
    setShowContextMenu: setShow,
    contextMenuCoords,
    openContextMenu,
    closeContextMenu,
  };
}
